
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[categoryUrl]/[slug]",
      function () {
        return require("private-next-pages/blog/[categoryUrl]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[categoryUrl]/[slug]"])
      });
    }
  